function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
      document.getElementById('mobmenu').classList.toggle('open-menu-panel');
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.includes('debug')) {
    const OpenThinking = { theme: { name: 'Bullet', version: window.BOOMR.themeVersion } };
    const tsiCheck = (Shopify.theme.theme_store_id === null || Shopify.theme.theme_store_id === '') ? '❌' : '✅';
    console.log(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} - ${Shopify.shop}`);
    alert(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} `);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

let scrollPosition = 0;
function lockBody() {
  scrollPosition = window.pageYOffset;
  document.body.style.overflow = 'hidden';
  document.body.style.maxHeight = '100vh';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
  document.body.style.paddingRight = getScrollbarWidth() + 'px'; // 防止滚动条消失导致页面抖动
}

function unlockBody() {
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('maxHeight');
  document.body.style.removeProperty('padding-right');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('width');
}

// 获取滚动条宽度
function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

// 加购弹窗逻辑
document.addEventListener('DOMContentLoaded', function() {
  // 快速添加按钮点击处理
  document.body.addEventListener('click', function(event) {
    if (event.target && event.target.closest('.quick-add-btn')) {
      event.preventDefault();
      const handle = event.target.closest('.quick-add-btn').dataset.productHandle;
      openQuickAddDrawer(handle);
    }
  })

  // 关闭按钮和遮罩层点击处理
  document.querySelector('.drawer-close')?.addEventListener('click', closeQuickAddDrawer);
  document.querySelector('.drawer-overlay')?.addEventListener('click', closeQuickAddDrawer);
  
  function openQuickAddDrawer(handle) {
    lockBody();

    const drawerBody = document.querySelector('.drawer-body');
    drawerBody.innerHTML = '<div class="drawer-loading"><div class="loading-spinner"></div></div>';
    
    document.querySelector('.quick-add-drawer').classList.add('active');
    document.querySelector('.drawer-overlay').classList.add('active');
    
    // 加载产品详情
    fetch(`/products/${handle}?view=quick-add`)
      .then(response => response.text())
      .then(html => {
        // 创建一个临时的 div 来解析 HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // 只获取 #mainContent 部分的内容
        const mainContent = doc.querySelector('#mainContent .shopify-section');
        if (mainContent) {
          // 获取并加载必要的脚本
          const scripts = doc.querySelectorAll('script[src]');
          scripts.forEach(script => {
            if (!document.querySelector(`script[src="${script.src}"]`)) {
              const newScript = document.createElement('script');
              newScript.src = script.src;
              document.body.appendChild(newScript);
            }
          });

          document.querySelector('.drawer-body').innerHTML = mainContent.innerHTML;
        }
        
        document.querySelector('.quick-add-drawer').classList.add('active');
        document.querySelector('.drawer-overlay').classList.add('active');
      });
  }

  // 使用事件委托从父元素监听
  document.querySelector('.quick-add-drawer')?.addEventListener('click', function(e) {
    const addToCartButton = e.target.closest('button[type="submit"]');
    if (addToCartButton?.closest('form[action="/cart/add"]')) {
      closeQuickAddDrawer();
    }
  }, { passive: true });
  
  function closeQuickAddDrawer() {
    unlockBody();

    document.querySelector('.quick-add-drawer').classList.remove('active');
    document.querySelector('.drawer-overlay').classList.remove('active');
  }
});